<template>
<div class="index" v-loading="loading" :element-loading-text="'Upload: ' + Number(p * 100) + '%'">
    <div class="userInfo" v-if="avater">
        <img v-bind:src='avater'></img>
        <div>
            {{nickname}}
        </div>
    </div>
    <div class="formBox">
        <div class="left">
            <div class="demo-input-suffix">
                <span><span style="color: red"> * </span>姓名：</span>
                <el-input placeholder="请输入候选人姓名" v-model="name">
                </el-input>
            </div>
            <div class="demo-input-suffix">
                <span><span style="color: red"> * </span>手机号码：</span>

                <el-input placeholder="请输入候选人手机号码" type="phone" v-model="phone">
                </el-input>
            </div>
            <p style="font-size: 12px;
    color: red;
    text-align: right;
    padding: 0 50px;">为了确保HR可以及时联系到候选人请填写候选人真实的手机号码</p>
            <!-- <div class="demo-input-suffix">
                <span><span style="color: red"> * </span>手机号码：</span>

                <el-input placeholder="请输入与简历一致的手机号码" type="phone" v-model="phone">
                </el-input>
            </div>

            <div class="demo-input-suffix">
                <span><span style="color: red"> * </span>邮箱地址：</span>
                <el-input placeholder="请输入与简历一致的email" v-model="email">
                </el-input>
            </div>

            <div class="demo-input-suffix">
                <span><span style="color: red"> * </span>公司名称：</span>
                <el-input placeholder="候选人所在公司名称" v-model="nowCompany">
                </el-input>
            </div>

            <div class="demo-input-suffix">
                <span><span style="color: red"> * </span>公司职位：</span>
                <el-input placeholder="候选人所在公司职位" v-model="nowJob">
                </el-input>
            </div> -->
        </div>
        <div class="right">
            <el-upload class="upload-demo" drag action="1" :http-request="setFile" :limit="1" :on-remove="remove" accept=".pdf,.doc,.docx" ref="upload">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">请上传word，pdf文件,word转pdf请点击<a href="http://wordtopdf.55.la/" target="_blank">http://wordtopdf.55.la/</a></div>
            </el-upload>
            <div>
                <el-radio v-model="radio" label="1">我自己的简历</el-radio>
                <el-radio v-model="radio" label="2">我推荐的候选人的简历</el-radio>
            </div>
        </div>

    </div>
    <div class="btn">
        <el-button type="primary" @click="submit">提交</el-button>
    </div>
    <div v-if="loginState" class="loginBox">
        <div class="qrcont" v-bind:style="{backgroundImage: 'url(' + qrUrl + ')'}" v-loading="qrloading" element-loading-text="二维码加载中"></div>
        <p class='qrtext'>请再【聘快快】小程序中扫描该二维码进行登录</p>
    </div>
</div>
</template>

<script>
/* eslint-disable */
import axios from 'axios'
import Config from '../config/index'
import OSS from 'ali-oss'
import qs from 'qs'
import {
    setTimeout
} from 'timers';
let QRCode = require('qrcode')

let client = new OSS({
    region: 'oss-cn-beijing',
    accessKeySecret: 'mPTRYqVIIWC8XxSeZqKFMPtFMWMfb5', // AccessKeySecret 去你的阿里云上控制台上找
    accessKeyId: 'LTAIvBaMapD5qPW9', // AccessKeyId 去你的阿里云上控制台上找
    bucket: 'linkedln',
    endpoint: 'images.qilinpin.cn',
    cname: true,
    secure: true
})

// client.useBucket('linkedln')

export default {
    name: 'home',
    components: {

    },
    data() {
        return {
            name: '',
            phone: '',
            email: '',
            id: '',
            file: false,
            fileUrl: '',
            radio: "1",
            p: '',
            loading: false,
            loadT: '',
            status: '',
            uuid: '',
            qrUrl: '',
            loginState: false,
            nowCompany: '',
            nowJob: '',
            avater: '',
            nickname: '',
                qrloading: false
        }
    },
    created: function () {

    },
    mounted: function () {
        this.avater = localStorage.getItem('avatarPath')
        this.nickname = localStorage.getItem('nickname')
        this.pdsq()
    },
    methods: {
        pdsq: function () {
            if (localStorage.getItem('token') === '' || localStorage.getItem('token') === undefined || localStorage.getItem('token') === null) {
                this.getQr()
                this.openSetTime()
            }
        },
        remove: function () {
            this.file = false
        },
        setFile: function (res) {
            this.file = res.file
        },
        uplaod: function (res) {
            let that = this
            let str = this.random_string(32)
            let gs = ''
            if (that.file.name.indexOf('.docx') > 0){
                gs = '.docx'
            } else if (that.file.name.indexOf('.doc') > 0){
                gs = '.doc'
            } else if (that.file.name.indexOf('.pdf') > 0){
                gs = '.pdf'
            }
            client.multipartUpload('uploadPdf/' + str + gs, this.file, {
                progress: function (p) {
                    that.loading = true;
                    console.log('Progress: ' + p);
                    that.p = p
                }
            }).then((res) => {
                console.log(res)
                that.fileUrl = 'https://images.qilinpin.cn/' + res.name
                that.post()
            }).catch((err) => {
                that.loading = false
                console.log(err);
            });
        },
        random_string: function (len) {
            len = len || 32
            var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
            var maxPos = chars.length
            var pwd = ''
            for (let i = 0; i < len; i++) {
                pwd += chars.charAt(Math.floor(Math.random() * maxPos))
            }
            return pwd
        },
        random_number: function (len) {
            len = len || 32
            var chars = '123456789'
            var maxPos = chars.length
            var pwd = ''
            for (let i = 0; i < len; i++) {
                pwd += chars.charAt(Math.floor(Math.random() * maxPos))
            }
            return pwd
        },
        post: function () {
            let that = this
            let url = Config.path + '/api/candidate/pc/upResume'
            let data = {
                // passCode: this.id,
                path: this.fileUrl,
                name: this.name.trim(),
                phone: this.phone.trim(),
                // email: this.email.trim(),
                // nowCompany: this.nowCompany.trim(),
                // nowJob: this.nowJob.trim(),
                flag: this.radio
            }
            axios({
                method: 'POST',
                url: url,
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token')
                },
                // data: qs.stringify(data),
                data: data,
            }).then(function (response) {
                console.log(response)
                if (response.data.success === '1') {
                    that.loading = false
                    // if (that.status === 'true') {
                    //     that.$alert('投递成功，请在【聘快快--我的--简历中心】中查看该简历', '提示', {
                    //         confirmButtonText: '确定',
                    //         callback: action => {}
                    //     });
                    // } else {
                    //     that.$alert('提交成功，请在【聘快快--我的--简历中心】查看该简历', '提示', {
                    //         confirmButtonText: '确定',
                    //         callback: action => {}
                    //     });
                    // }
                    that.name = '';
                    that.phone = '';
                    that.email = '';
                    that.file = false;
                    that.fileUrl = '';
                    that.radio = '1';
                    that.$refs.upload.clearFiles();
                    that.$router.push('/success')
                } else {
                    that.loading = false
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function (error) {
                that.loading = false

                // eslint-disable-next-line
                console.log(error)
            })
        },
        submit: function () {
            if (this.name !== '' && this.phone !== '' && this.file) {
                this.uplaod()
            } else {
                this.$message({
                    message: '信息填写不完整',
                    type: 'warning'
                });
            }
        },
        getQr: function () {
            let that = this
            let url = Config.path + '/api/candidate/qRcode/getqRcodeUUID'
            that.qrloading = true
            axios({
                method: 'POST',
                url: url,
                headers: {
                    'Content-Type': 'application/json'
                },
            }).then(function (response) {
                console.log(response)
                if (response.data.success === '1') {
                    that.uuid = response.data.content.uuId
                    QRCode.toDataURL(that.uuid, function (err, url) {
                        that.qrUrl = url
                        that.loginState = true
                        that.qrloading = false
                    })
                    that.initWebsocket()
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function (error) {
                that.loading = false

                // eslint-disable-next-line
                console.log(error)
            })
        },

        initWebsocket: function () {
            let path = Config.wssPath + '/api/candidate/websocket/'
            this.websocket = new WebSocket(path + this.uuid);
            this.websocket.onopen = this.websocketonopen;
            this.websocket.onerror = this.websocketonerror;
            this.websocket.onmessage = this.websocketonmessage;
            this.websocket.onclose = this.websocketclose;
        },
        websocketonopen: function () {
            console.log("WebSocket连接成功");
        },
        websocketonerror: function (e) { //错误
            console.log("WebSocket连接发生错误");
        },
        websocketonmessage: function (e) { //数据接收 
            debugger;
            if (e.data === '00000') {
                this.$notify({
                    title: '警告',
                    message: 'sorry,您尚未在聘快快平台注册，请前往聘快快公众号，点击【我是猎头】进行注册',
                    type: 'warning',
                    duration: 0
                });
            }
            const redata = JSON.parse(e.data);
            console.log(redata.value);
            localStorage.setItem('token', redata.openid)
            localStorage.setItem('nickname', redata.nickname)
            localStorage.setItem('avatarPath', redata.avatarPath)
            this.avater = redata.avatarPath
            this.nickname = redata.nickname
            this.$notify({
                title: '提示',
                message: '登录成功',
                type: 'success',
                duration: 1000
            });
            this.loginState = false
        },

        websocketsend: function (agentData) { //数据发送 
            this.websocket.send(agentData);
        },
        websocketclose: function (e) { //关闭 
            console.log("connection closed (" + e.code + ")");
        },
        openSetTime: function () {
            let that = this
            setTimeout(function () {
                if (localStorage.getItem('token') === '' || localStorage.getItem('token') === undefined || localStorage.getItem('token') === null) {
                    that.getQr()
                }
            }, 160000)
        }
    }
}
</script>

<style scoped>
.index {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100vw;
    min-height: 100vh;
    justify-content: center;
    /* background-image: url('https://images.qilinpin.cn/static/coffee1.jpg'); */
    background-size: cover;
    background-attachment: fixed;
}

.formBox {
    min-width: 100vw;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.8);
}

.formBox>div {
    margin-top: 20px;
    width: 500px;
}

.formBox>.left {
    border-right: 2px solid #eaeaea;
}

.formBox>.right {
    padding: 20px 50px;
    box-sizing: border-box;
}

.formBox .demo-input-suffix {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 20px 50px;
}

.formBox .demo-input-suffix>span {
    padding: 10px;
    color: darkgray;
    width: 150px;
}

.formBox .demo-input-suffix .el-input {
    /* background-color: #000; */
}

/* .formBox .demo-input-suffix .el-input>input{
    background-color: #000;
} */

.formBox button {
    margin-top: 60px;
}

.loginBox {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.7);
    margin-top: 0 !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.qrcont {
    width: 300px;
    height: 300px;
    background-size: 100%, 100%;
}

.qrtext {
    color: #ffffff;
    padding-top: 20px;
    text-align: center;
}

.userInfo {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    position: absolute;
    right: 20px;
    top: 20px;
    color: darkgray;
}

.userInfo img {
    width: 30px;
    height: 30px;
    border-radius: 100%;
    margin-right: 10px;
}

.btn {
    margin-top: 50px;
}
</style>
<style>
.formBox .demo-input-suffix .el-input>input {
    border: none;
    background-color: #f8f8f8;
}
</style>
